import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { MOCK_NAKSHATRAS } from '../data/homamData';
import { getHomamPath } from '../utils/domain';

export function HomamFlashTicker() {
  const scrollContainerRef = useRef(null);

  return (
    <div className="homam-flash-ticker-wrapper" aria-label="27 Nakshatra Homam Live Schedule Ticker">
      {/* 👑 Left Corner 27 Nakshatras Blinking & Glowing Emblem Badge */}
      <Link
        to={`${getHomamPath('/')}#nakshatras`}
        className="homam-ticker-corner-badge"
        title="27 Nakshatras • 27 Days 27 Homams - Click to view schedule"
      >
        <div className="badge-inner-content">
          <span className="ticker-badge-number">27</span>
          <div className="ticker-badge-text-group">
            <div className="ticker-badge-title-row">
              <span className="badge-live-blink-dot" title="Live Pooja Schedule"></span>
              <span className="ticker-badge-title">NAKSHATRAS</span>
              <Sparkles className="badge-sparkle-icon" />
            </div>
            <span className="ticker-badge-subtitle">27 DAYS • 27 HOMAMS</span>
          </div>
        </div>
      </Link>

      {/* Edge-to-Edge Continuous Smooth Marquee Track */}
      <div className="homam-ticker-scroll-track" ref={scrollContainerRef}>
        <div className="homam-ticker-content">
          {MOCK_NAKSHATRAS.map((star, idx) => (
            <React.Fragment key={`ticker-item-${star.id || idx}`}>
              <Link
                to={getHomamPath(`/nakshatra/${star.slug}`)}
                className="homam-ticker-item"
                title={`Day ${star.orderIndex}: ${star.nameEn} (${star.nameTa}) - ${star.assignedDate} • Click to view full details`}
              >
                <span className="homam-ticker-star-name">{star.nameEn}</span>
                <span className="homam-ticker-star-date">{star.assignedDate}</span>
              </Link>
              <span className="homam-ticker-divider">✦</span>
            </React.Fragment>
          ))}

          {/* Duplicate set for seamless continuous marquee loop */}
          {MOCK_NAKSHATRAS.map((star, idx) => (
            <React.Fragment key={`ticker-item-dup-${star.id || idx}`}>
              <Link
                to={getHomamPath(`/nakshatra/${star.slug}`)}
                className="homam-ticker-item"
                title={`Day ${star.orderIndex}: ${star.nameEn} (${star.nameTa}) - ${star.assignedDate} • Click to view full details`}
              >
                <span className="homam-ticker-star-name">{star.nameEn}</span>
                <span className="homam-ticker-star-date">{star.assignedDate}</span>
              </Link>
              <span className="homam-ticker-divider">✦</span>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomamFlashTicker;
